// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"TabButton_tabButton__kZaCy","active":"TabButton_active__QgkA_","inactive":"TabButton_inactive__dhRBy","label":"TabButton_label__IMZqi"};